var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { config } from '..';
export var ReturnCode;
(function (ReturnCode) {
    ReturnCode["Succees"] = "200";
    ReturnCode["NotLogin"] = "401";
    ReturnCode["NotAllow"] = "403";
    ReturnCode["NotFound"] = "404";
})(ReturnCode || (ReturnCode = {}));
/**
 * 微信代理接口
 * @export
 * @param {CwInput} options
 */
export function proxyApi(options) {
    return new Promise((resolve, reject) => {
        window.cw('ajax', 'proxy', (data) => {
            if (data.result && data.result.error) {
                reject(data.result.error);
            }
            else {
                resolve(data.result);
            }
        }, reject, options);
    });
}
export function proxyRequest(params) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        return (_a = config.proxyRequest) === null || _a === void 0 ? void 0 : _a.post('/proxy', params);
    });
}
